export async function retrieveLinkedWalletMockedCall(
  _backendJWT: string
): Promise<string | undefined> {
  return "0x815546E2E35dC9aC8A90f001cc7A859f4b21E1fd";
}
